define([], function() {
	var pharmacyRefillPrescription = {
		prescriptionNumberTextBoxCounter: 0,
		eventHandlers: {
			refillPrescriptionSubmit: function(form) {
				form.submit();
			},
			changeRefillOrder: function() {
				let form = $('#refillPrescriptionConfirmationForm');
				form.attr('action', 'warehouse-pickup-prescription-refill');

				form.submit();
			},
			submitRefillOrder: function(url) {
				pharmacyRefillPrescription.urls.ajaxSubmitRefillPrescriptionCmdURL = url || rxStatusUrl;

				$.ajax({
					type: 'POST',
					url: pharmacyRefillPrescription.urls.ajaxSubmitRefillPrescriptionCmdURL,
					dataType: 'json',
					data: $('#refillPrescriptionConfirmationForm').serialize(),
					success: pharmacyRefillPrescription.callbacks.onSubmitRefillOrderSucess,
					error: pharmacyRefillPrescription.callbacks.onSubmitRefillOrderError,
				});
			},
		},
		callbacks: {
			onSubmitRefillOrderSucess: function(data) {
				data = DOMPurify.sanitize(data);
				$('#refill-prescription-loading').hide();

				if (data.success == true) {
					// Dynamically create refill status table
					let statusTable = $('#prescription-status-results-table');
					let dataStr = COSTCO.rxPrescriptionStatus.sanitize(data);
					const dataObj = $.parseJSON(dataStr);
					let prescriptionList = $.parseJSON(dataObj.responseVO.prescriptionList);
					$.each(prescriptionList, function(index, value) {
						let statusLineElement = $('#prescription-status-result-tr-template').clone();
						let column1 = $(statusLineElement).find('.column-1 div');
						let column2 = $(statusLineElement).find('.column-2');
						let column3 = $(statusLineElement).find('.column-3');
						let column4 = $(statusLineElement).find('.column-4');

						let statusFullMessage = pharmacyRefillPrescription.getRxStatusMessage(value.status);
						let statusLabel = pharmacyRefillPrescription.getRxStatusLabel(value.status);

						if (pharmacyRefillPrescription.isCheckStatusFound(value.status)) {
							column1.attr('class', 'icon-check');
							column3.append('<span role="img" aria-hidden="true" class="co-check-circle mid-allign"></span>' + ' ' + '<span class="mid-allign">'+ statusLabel + '</span>');
							if ((value.status == pharmacyRefillPrescription.rxStatuses.RXVALID || value.status == pharmacyRefillPrescription.rxStatuses.RXACTIONOK)
								&& value.pickUpDate != null) {
								var pickUpDateStr = DOMPurify.sanitize(value.pickUpDate);
								column4.append(statusFullMessage + ' ' + pickUpDateStr);
							} else {
								column4.append(statusFullMessage);
							}
						} else if (pharmacyRefillPrescription.isWaitStatusFound(value.status)) {
							column1.attr('class', 'icon-wait');
							column3.append('<span class="fi-clock mid-allign"></span>' + ' ' + '<span class="mid-allign">'+ statusLabel + '</span>');
							column4.append(statusFullMessage);
						} else if (pharmacyRefillPrescription.isAlertStatusFound(value.status)) {
							column1.attr('class', 'icon-alert');
							column3.append('<span class="co-caution mid-allign"></span>' + ' ' + '<span class="mid-allign">'+ statusLabel + '</span>');
							column4.append(statusFullMessage);
						} else {
							column1.attr('class', 'icon-block');
							column3.append('<span class="co-caution mid-allign"></span>' + ' ' + '<span class="mid-allign">'+ messages.REFILL_PRESCRIPTION_STATUS_PATIENT_ACTION_REQUIRED + '</span>');
							column4.append(statusFullMessage);
						}
						column2.append(DOMPurify.sanitize(value.number));
						statusLineElement.removeAttr('id');
						statusLineElement.show();
						statusTable.append(statusLineElement);
					});

					let confirmationResponseElement = $('#refill-prescription-confirmation-response');
					confirmationResponseElement.removeAttr('style');

					let nextStepsElements = $('#next-steps-success');
					nextStepsElements.removeAttr('style');
					nextStepsElements.show();
				} else {
					pharmacyRefillPrescription.handleSubmitError(data);
				}

				$('#pharmacyInfo').show();
			},
			onSubmitRefillOrderError: function(data) {
				$('#refill-prescription-loading').hide();
				$('#pharmacyInfo').show();
				pharmacyRefillPrescription.handleSubmitError(data);
			},
		},
		urls: {
			ajaxSubmitRefillPrescriptionCmdURL: null,
		},
		handleSubmitError: function(data) {
			let errorContainer = $('#refill-prescription-confirmation-error');
			$(errorContainer).find('#line-1').text(messages.PRESCRIPTION_MESSAGE_SYSTEM_ISSUE_LINE_1 + ' ' + messages.PRESCRIPTION_MESSAGE_SYSTEM_ISSUE_LINE_2);
			$('#refill-prescription-confirmation-error').show();
			$('#refill-prescription-confirmation-error').removeClass('hide');

			let nextStepsElements = $('#next-steps-error');
			nextStepsElements.removeAttr('style');
			nextStepsElements.show();
		},
		rxStatuses: {
			RXVALID: 'RXVALID',
			RXACTIONOK: 'RXACTIONOK',
			RXINQUEUE: 'RXINQUEUE',
			RXREADYFORPICKUP: 'RXREADYFORPICKUP',
			RXEXPIRED: 'RXEXPIRED',
			RXOUTOFREFILLS: 'RXOUTOFREFILLS',
			RXWAITONDOC: 'RXWAITONDOC',
			RXVERIFY: 'RXVERIFY',
			RXTOOSOON: 'RXTOOSOON',
			RXNARCOTIC: 'RXNARCOTIC',
			RXALREADYPICKEDUP: 'RXALREADYPICKEDUP',
			RXALREADYSHIPPED: 'RXALREADYSHIPPED',
			RXGENERICAVAILABLE: 'RXGENERICAVAILABLE',
			RXNOTFOUND: 'RXNOTFOUND',
		},
		getRxCheckStatuses: function() {
			return [pharmacyRefillPrescription.rxStatuses.RXVALID, pharmacyRefillPrescription.rxStatuses.RXACTIONOK, pharmacyRefillPrescription.rxStatuses.RXINQUEUE, pharmacyRefillPrescription.rxStatuses.RXREADYFORPICKUP, pharmacyRefillPrescription.rxStatuses.RXALREADYSHIPPED, pharmacyRefillPrescription.rxStatuses.RXALREADYPICKEDUP];
		},
		getRxWaitStatuses: function() {
			return [pharmacyRefillPrescription.rxStatuses.RXEXPIRED, pharmacyRefillPrescription.rxStatuses.RXOUTOFREFILLS, pharmacyRefillPrescription.rxStatuses.RXWAITONDOC];
		},
		getRxAlertStatuses: function() {
			return [pharmacyRefillPrescription.rxStatuses.RXNOTFOUND, pharmacyRefillPrescription.rxStatuses.RXVERIFY, pharmacyRefillPrescription.rxStatuses.RXTOOSOON, pharmacyRefillPrescription.rxStatuses.RXGENERICAVAILABLE, pharmacyRefillPrescription.rxStatuses.RXNARCOTIC];
		},
		getRxBlockStatuses: function() {
			return [];
		},
		isCheckStatusFound: function(status) {
			let match = false;
			$.each(pharmacyRefillPrescription.getRxCheckStatuses(), function(index, value) {
				if (status == value) {
					match = true;
				}
			});
			return match;
		},
		isWaitStatusFound: function(status) {
			let match = false;
			$.each(pharmacyRefillPrescription.getRxWaitStatuses(), function(index, value) {
				if (status == value) {
					match = true;
				}
			});
			return match;
		},
		isAlertStatusFound: function(status) {
			let match = false;
			$.each(pharmacyRefillPrescription.getRxAlertStatuses(), function(index, value) {
				if (status == value) {
					match = true;
				}
			});
			return match;
		},
		isBlockStatusFound: function(status) {
			let match = false;
			$.each(pharmacyRefillPrescription.getRxBlockStatuses(), function(index, value) {
				if (status == value) {
					match = true;
				}
			});
			return match;
		},
		getRxStatusMessage: function(status) {
			let rxStatusMessage;
			switch (status) {
				case pharmacyRefillPrescription.rxStatuses.RXVALID:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXVALID;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXACTIONOK:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXACTIONOK;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXINQUEUE:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXINQUEUE;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXREADYFORPICKUP:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXREADYFORPICKUP;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXEXPIRED:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXEXPIRED;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXOUTOFREFILLS:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXOUTOFREFILLS;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXWAITONDOC:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXWAITONDOC;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXVERIFY:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXVERIFY;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXTOOSOON:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXTOOSOON;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXNARCOTIC:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXNARCOTIC;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXALREADYPICKEDUP:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXALREADYPICKEDUP;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXALREADYSHIPPED:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXALREADYSHIPPED;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXNOTFOUND:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXNOTFOUND;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXGENERICAVAILABLE:
					rxStatusMessage = messages.REFILL_PRESCRIPTION_MESSAGE_RXGENERICAVAILABLE;
					break;
				default:
					rxStatusMessage = messages.PRESCRIPTION_MESSAGE_UNKNOWNS_STATUS;
			}

			return rxStatusMessage;
		},

		/**
	     * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val() to get unformatted value
	     */
		maskInput: function() {
	    	$('#RefillPrescriptionForm').find('#refill_prescription_phoneNumber').unmask().mask('000-000-0000');
	    },

		init: function() {
			COSTCO.pharmacyRefillPrescription.eventHandlers.submitRefillOrder();
		},

		getRxStatusLabel: function(status) {
			let rxStatusLabel;
			switch (status) {
				case pharmacyRefillPrescription.rxStatuses.RXVALID:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXVALID;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXACTIONOK:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXACTIONOK;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXINQUEUE:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXINQUEUE;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXREADYFORPICKUP:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXREADYFORPICKUP;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXEXPIRED:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXEXPIRED;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXOUTOFREFILLS:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXOUTOFREFILLS;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXWAITONDOC:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXWAITONDOC;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXVERIFY:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXVERIFY;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXTOOSOON:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXTOOSOON;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXNARCOTIC:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXNARCOTIC;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXALREADYPICKEDUP:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXALREADYPICKEDUP;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXALREADYSHIPPED:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXALREADYSHIPPED;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXNOTFOUND:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXNOTFOUND;
					break;
				case pharmacyRefillPrescription.rxStatuses.RXGENERICAVAILABLE:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_LABEL_RXNOTFOUND;
					break;
				default:
					rxStatusLabel = messages.REFILL_PRESCRIPTION_STATUS_PATIENT_ACTION_REQUIRED;
			}
			return rxStatusLabel;
		},

	};

	// Expose fsamodal to the global scope.
    if (typeof window.COSTCO === 'undefined') {
        window.COSTCO = new Object();
    }
    window.COSTCO.pharmacyRefillPrescription = pharmacyRefillPrescription;
	return pharmacyRefillPrescription;
});



// WEBPACK FOOTER //
// ./js/rx/pharmacyRefillPrescription.js